import { Text } from '@vallourec-ui/vallourec-ui'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
`

export const LoadingContainer = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  justify-content: center;
  align-items: center;
`

export const LoadingBarContainer = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors['neutral-color-10']};
  height: 8px;
  border-radius: 4px;
  line-height: 20px;
`

export const LoadingBar = styled.div`
  height: 100%;
  background-color: ${({ theme }) => theme.colors['brand-color-primary-1']};
  transition: width 0.5s ease-in-out;
  border-radius: 4px;
`

export const LoadingLabelContainer = styled.div`
  padding-left: 1rem;
  background-color: #fff;
`

export const StyledLabel = styled(Text)`
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  font-size: ${({ theme }) => theme.fontSizes['text-sm']};
`
